import { render } from "./PledgeCreation.vue?vue&type=template&id=70174b3a&scoped=true"
import script from "./PledgeCreation.vue?vue&type=script&lang=js"
export * from "./PledgeCreation.vue?vue&type=script&lang=js"

import "./PledgeCreation.vue?vue&type=style&index=0&id=70174b3a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70174b3a"]])

export default __exports__